import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntHttpErrors: SelectDataObject[] = [
    { i: 303, t: 'Bereits vorhanden' },
    { i: 304, t: 'Keine Änderungen vorhanden' },
    { i: 400, t: 'Falsche Anfrage' },
    { i: 401, t: 'Nicht autorisiert' },
    { i: 403, t: 'Nicht autorisiert' },
    { i: 404, t: 'Nicht gefunden' },
    { i: 405, t: 'Methode nicht erlaubt' },
    { i: 408, t: 'Zeitüberschreitung' },
    { i: 415, t: 'Nicht unterstützter Medientyp' },
    { i: 500, t: 'Interner Serverfehler' },
    { i: 501, t: 'Nicht implementiert' },
    { i: 502, t: 'Gateway nicht erreichbar' },
    { i: 503, t: 'Service aktuell nicht verfügbar' },
    { i: 504, t: 'Gateway Zeitüberschreitung' },
];
export default sIntHttpErrors;
